import { Component, OnInit, Input } from '@angular/core';
import { GeopointsService } from 'src/app/geopoints/services/geopoints.service';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';

@Component({
  selector: 'app-user-geopoints-config',
  templateUrl: './user-geopoints-config.component.html',
  styleUrls: ['./user-geopoints-config.component.scss', './../components-conf.scss']
})
export class UserGeopointsConfigComponent implements OnInit {
  @Input() filterOptionsBy : string = ""

  public configSections = configSections;

  public columnOptions = [
    { label: 'Ver Geopunto', value: 'showPoint' },
    { label: 'Nombre de geopunto', value: 'name' },
    { label: 'Ver nombres en el mapa', value: 'showPointName' },
    { label: 'Edicion', value: 'edit' },
  ]
  public selectedColumns : any[] = [];



  constructor(
    public geopointService : GeopointsService
  ) { }

  ngOnInit(): void {

    this.selectedColumns = Object.keys(this.geopointService.config.tableColumns)
      .filter(key => this.geopointService.config.tableColumns[key]);
  }
  
  public updateVisibleColumns() {
    Object.keys(this.geopointService.config.tableColumns).forEach(key => {
      this.geopointService.config.tableColumns[key] = false;
    });

    this.selectedColumns.forEach((column)=>{
      this.geopointService.config.tableColumns[column] = true
    })
  }

}
